<template>
  <div style="padding: 20px;">
    <button
      class="button gray"
      @click="$router.go(-1)"
      style="margin-bottom: 20px;">
      <font-awesome-icon
        class="icon"
        :icon="['fas', 'arrow-left']"
      />
      Retour
    </button>

    <LoaderView v-if="recipe == null && !loadError" />

    <div v-else-if="loadError" class="recipe-error">
      <strong>Impossible d’afficher cette recette.</strong>
      <span>Réessaie dans quelques secondes.</span>
      <button class="button" @click="reload">Réessayer</button>
    </div>

    <div v-else>
      <DishCard
        :recipe="recipe"
        @update="recipe = $event"
      />
    </div>
  </div>
</template>

<script>

import { api } from "@/api";
import LoaderView from "@/components/LoaderView.vue";
import DishCard from "@/views/DishCard.vue";

export default {
  name: "RecipeView",
  components: {
    LoaderView,
    DishCard,
  },
  data() {
    return {
      recipe: null,
      loadError: false,
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      this.recipe = null;
      this.loadError = false;
      api.get(`/recipes/${this.id}/`)
        .then((response) => {
          this.recipe = response.data.recipe || response.data;
        })
        .catch(() => {
          this.loadError = true;
        });
    },
  }
};

</script>


<style scoped>
.recipe-error {
  display: grid;
  gap: 8px;
  justify-items: start;
  padding: 18px;
  border: 1px solid #ead8d2;
  border-radius: 12px;
  background: #fff8f5;
  color: #6f493d;
}
.recipe-error span {
  color: #7d6b65;
}
</style>
